import { atom } from 'recoil';

export const refreshIsGiftCardEligibleSelectorAtom = atom({
    key: 'refreshIsGiftCardEligibleSelectorAtom',
    default: {}
});
